export const MerchandisingProgramQuoteItemSubCategoryEnumValue = {
  None: 0,

  Quarterly: 1,

  BiYearly: 10,
  Yearly: 20,
  Once: 30,
};

export const MerchandisingProgramQuoteItemSubCategoryEnum = [
  {
    value: MerchandisingProgramQuoteItemSubCategoryEnumValue.Quarterly,
    labelFrench: 'Trimestriel',
    labelEnglish: 'Quarterly',
  },
  {
    value: MerchandisingProgramQuoteItemSubCategoryEnumValue.BiYearly,
    labelFrench: 'Semestriel',
    labelEnglish: 'Bi-Yearly',
  },
  {
    value: MerchandisingProgramQuoteItemSubCategoryEnumValue.Yearly,
    labelFrench: 'Annuel',
    labelEnglish: 'Yearly',
  },
  {
    value: MerchandisingProgramQuoteItemSubCategoryEnumValue.Once,
    labelFrench: 'Une fois',
    labelEnglish: 'Once',
  },
];

export default MerchandisingProgramQuoteItemSubCategoryEnum;
